import { useAppData } from '@modules/root';
import { BottomLinkSection } from '@rocco/ui/bottom-link-section/components/BottomLinkSection';
import { ReactComponent as LogoIcon } from '@rocco/icons/svg/logo.svg';
export const PageBottomSection = ({
    openLogin,
    overriteTracking,
}: {
    openLogin: (url: string) => void;
    overriteTracking?: (event: string, sectionName: string) => void;
}) => {
    const { bottomContent } = useAppData();

    return (
        <BottomLinkSection
            whyArchiPro={bottomContent?.whyArchiPro.map((item) => ({
                ...item,
                icon: getIcon(),
            }))}
            bottomLink={bottomContent?.bottomLink}
            openLogin={openLogin}
            overriteTracking={overriteTracking}
        />
    );
};

// TODO: Add icons for other icons if any
const getIcon = () => {
    return <LogoIcon className="size-5" />;
};
